// extracted by mini-css-extract-plugin
export default {"element":"GuildModal_element__GXEMc","heading":"GuildModal_heading__AfYLO","desc":"GuildModal_desc__tbcrr","form":"GuildModal_form__xb3O3","status":"GuildModal_status__cFGpm"};